// The org superadmin sessions read and write under. A superadmin has no org
// membership (AuthProvider leaves `org` null), so AppProvider writes their runs
// here, and AuthProvider's `effectiveOrg` is this org's doc: the consent gate
// reads the same org the writes land in (spec 2026-10-07 Part 0.5). Seeded by
// scripts/seed-firestore.mjs; dataPooling backfilled by
// scripts/backfill-crimsonscan-pooling.mjs (which hardcodes the same id).
export const SUPERADMIN_ORG_ID = 'crimsonscan';
